<template>
  <DocumentDetailV2 v-if="useV2" :document="document" />
  <DocumentDetail v-else :document="document" />
</template>

<script>
import { mapGetters } from 'vuex'
import DocumentDetail from './DocumentDetail.vue'
import DocumentDetailV2 from './DocumentDetailV2.vue'

export default {
  name: 'DocumentDetailWrapper',
  props: {
    document: [String, Number]
  },
  components: {
    DocumentDetail,
    DocumentDetailV2
  },
  computed: {
    ...mapGetters({
      got_feature: 'got_feature'
    }),
    useV2() {
      return this.got_feature('feature_document_detail_split_pane')
    }
  }
}
</script>
